import { AfterViewInit, Component, OnInit } from '@angular/core';
import { SharedService } from '../service/shared.service';
import { FormGroup, FormControl, FormBuilder } from '@angular/forms';
import { Validators } from 'ngx-editor';
import { ApiServiceService } from '../service/api-service.service';
import { configuration } from 'src/configuration';

@Component({
  selector: 'app-payment-coupon',
  templateUrl: './payment-coupon.component.html',
  styleUrls: ['./payment-coupon.component.css']
})
export class PaymentCouponComponent  implements AfterViewInit, OnInit {

  showCouponInput: boolean = true;
  showCouponCard: boolean = false;
  isSubmitted = false;
paymentcouponForm: FormGroup;
myFormSubmit = false;

constructor(
  private formBuilder: FormBuilder,
  private apiService: ApiServiceService,
  public shared: SharedService
) {
  this.paymentcouponForm = this.formBuilder.group({
    coupon_code: ['', Validators.required],
  });
  this.shared.isWhiteMenu = true;

}

get formControls() {
  return this.paymentcouponForm.controls;
}
  ngOnInit(): void {
    
  }

  ngAfterViewInit(): void {
    this.shared.includeMainScript();
  }


  async applyCoupon() {
    this.showCouponInput = false;
    this.showCouponCard = true;
    this.myFormSubmit=true;
      console.log(this.paymentcouponForm.value)
      let res = await this.apiService.POST_apiRequest(configuration.ENDPOINT.CHANGE_PASSWORD,
        this.paymentcouponForm.value
      );
      console.log("res", res);
      if (res && !res.error) {
        this.isSubmitted = true;
      }
    }


  removeCoupon() {
    this.showCouponInput = true;
    this.showCouponCard = false;
  }
}

